import gql from 'graphql-tag'

export const GET_VEHICLE_DETAILS = gql`
  query Vehicle($filter: GetVehicleFilter!) {
    vehicle(filter: $filter) {
      isSuccessful
      message
      vehicle {
        id
        companyId
        driver1Id
        driver2Id
        garageId
        tonnage
        volume
        fuelEfficiency
        fuelCapacity
        odometer
        status
        imei
        licensePlate
        vehicleTypeId
        sensor {
          sensorCode
          statusText
        }
        device {
          deviceCode
          deviceName
        }
        vehicleType {
          vehicleTypeId
          companyId
          isActive
          manufacturer
          model
          type
          category
          transmissionType
          fuelType {
            fuelTypeId
            name
            category
          }
          tonnage
          volume
          fuelEfficiency
          icon
          hasRelation
        }
        thermoType
        chassisNumber
        machineNumber
        carrosserie
        year
        hullNo
        idleDuration
        parkingDuration
        door1
        door2
      }
    }
  }
`
